import { render } from "./AdminCertificatesView.vue?vue&type=template&id=5f1e8da5&scoped=true&ts=true"
import script from "./AdminCertificatesView.vue?vue&type=script&lang=ts"
export * from "./AdminCertificatesView.vue?vue&type=script&lang=ts"

import "@/assets/admin-crud.css?vue&type=style&index=0&id=5f1e8da5&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1e8da5"]])

export default __exports__